import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import {
  onClickChangeUserStatus,
  onClickUpdateBusiness,
} from "../../modules/actions/index";
import {
  callApiUsersList,
  callApiUpdateUser,
  callApiBusinessesList,
  callApiGetBusiness,
} from "../../services";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { authUserData } from "../../helpers";
import Header from "../../components/Header";
import ChangeStatusConfirmationModal from "../../components/modals/ChangeStatusConfirmationModal";
import BusinessAdminHeader from "../../components/BusinessAdminHeader";

class Companies extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      userData: null,
      users: null,
      userId: null,
      userStatus: null,
      deletedId: null,
      showModal: false,
      businessId: null,
      isBusinessAdmin: false,
    };
  }

  componentDidMount = async () => {
    let currentBusinessId;
    const userData = authUserData();
    this.setState({
      userData: userData,
    });

    if (userData && userData.isAdmin && userData.isAdmin === true) {
      await this.renderBusinessList();
    } else {
      window.history.back();
    }

    if (userData && userData.isAdmin && userData.isAdmin === true) {
      currentBusinessId = null;
    } else {
      const tempBusinessDetails =
        userData &&
        userData.businessDetails &&
        userData.businessDetails.length > 0 &&
        userData.businessDetails.filter((v, i) => {
          return v.primaryUser === true && v.userType === "admin" && v;
        });

      if (tempBusinessDetails && tempBusinessDetails.length == 0) {
        this.props.history.push("/dashboard/");
        return;
      }

      currentBusinessId = tempBusinessDetails[0].businessId;

      // console.log("tempBusinessDetails", tempBusinessDetails[0].businessId);

      this.setState(
        {
          businessId: tempBusinessDetails[0].businessId,
          isBusinessAdmin: true,
        },
        () => {
          // console.log("B ID", this.state.businessId);
        }
      );
    }
  };

  /* componentDidUpdate = async () => {
    console.log("Component did update");
    //
    console.log("OUTSIDE ", this.state.renderUser);

    if (this.state.renderUser) {
      console.log("INSIDE ", this.state.renderUser);

      this.renderUserList();

      this.setState({
        renderUser: false,
      });
    }
  }; */

  renderBusinessList = async () => {
    callApiBusinessesList({})
      .then((res) => {
        console.log("api res", res);
        if (res.success && res.data && res.data.length > 0) {
          this.setState({
            companies: res.data,
          });
        }
      })
      .catch((error) => {
        // console.log("Dashboard fetch saq data ... error", error);
      });
  };

  onShowModal = () => {
    this.setState({ showModal: true });
  };

  onCloseModal = () => {
    this.setState({ showModal: false });
  };

  onSelectAction = (status, businessId) => {
    this.setState({ showModal: true, businessId: businessId, status: status });
  };

  handleChangeStatus = () => {
    // console.log("01. handleChangeStatus");

    this.props.onClickUpdateBusiness({
      purpose: "UPDATE_BUSINESS_STATUS",
      businessId: this.state.businessId,
      status: this.state.status,
    });
    this.renderBusinessList();
  };

  componentWillReceiveProps(newProps) {
    if (
      newProps.userData &&
      newProps.userData &&
      newProps.userData.success === true
    ) {
      this.renderBusinessList();
    }
  }

  render() {
    const { history } = this.props;
    const {
      userData,
      users,
      deletedId,
      showModal,
      companies,
      isBusinessAdmin,
    } = this.state;

    return (
      <>
        <ToastContainer />

        <div className="cell small-12 medium-10" id="maincontent">
          {userData && !userData.isAdmin && (
            <BusinessAdminHeader isBusinessAdmin={isBusinessAdmin} />
          )}

          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="completedsaqs">
                <div className="module-header">
                  <h3>Companies</h3>
                  <Link to="/control-panel/companies/create">
                    <button className="button nxt-btn">Create Company</button>
                  </Link>
                </div>

                <br />
                <div id="compltedsaqs-table">
                  <table>
                    <thead>
                      <tr>
                        <th width="200">Business Name</th>
                        <th>Website</th>
                        <th>Subdomain</th>
                        <th>Users</th>
                        <th>Status</th>
                        <th width="150">Created At</th>
                        <th width="150">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {companies && companies.length > 0 ? (
                        companies
                          .slice(0)
                          .reverse()
                          .map((v, i) => {
                            return (
                              <tr key={uuidv4()}>
                                <td>{v.businessName}</td>
                                <td>{v.website}</td>
                                <td>{v.subdomain}</td>
                                <td>
                                  <Link to={`/control-panel/users?businessId=${v._id}`}>Users</Link>
                                </td>
                                <td>
                                  {v.status.charAt(0).toUpperCase() +
                                    v.status.slice(1)}
                                </td>
                                <td>
                                  {moment(v.createdAt).format("MMMM Do YYYY")}
                                </td>
                                <td>
                                  <select
                                    onChange={(e) =>
                                      this.onSelectAction(e.target.value, v._id)
                                    }
                                  >
                                    <option>Options</option>
                                    {v.status && v.status === "active" && (
                                      <option value="inactive">Inactive</option>
                                    )}
                                    {v.status && v.status === "inactive" && (
                                      <option value="active">Active</option>
                                    )}
                                  </select>
                                </td>
                              </tr>
                            );
                          })
                      ) : (
                        <tr>
                          <td colSpan="3">No records.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <ChangeStatusConfirmationModal
            history={this.props.history}
            handleChangeStatus={() => this.handleChangeStatus()}
            showModal={showModal}
            onCloseModal={() => this.onCloseModal()}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.userStore.user,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      onClickChangeUserStatus,
      onClickUpdateBusiness,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Companies);
